import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Menu from './Menu';
import UserProfileCard from './UserProfileCard';
import smartClickLogo from '../../images/smartclick-black-min.svg';
import { AppBar, Box, Toolbar, IconButton, Drawer, List, ListItem, ListItemText, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const NavigationBar = ({ user, menuItems, onMenuSelected, selectedMenuIndex, subOptions, selectedSubOption, onUserProfileSelect }) => {
    const { t } = useTranslation();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setIsDrawerOpen(open);
    };

    return (
        <AppBar 
            position="fixed" 
            sx={{ 
                backgroundColor: '#F8F9FA', 
                boxShadow: 'none' 
            }}>
            <Toolbar 
                sx={{ 
                    backgroundColor: '#F8F9FA', 
                    height: 100, 
                    display: 'flex', 
                    justifyContent: 'space-between' 
                }}>
                {/* Mobile Menu Icon */}
                <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleDrawer(true)}
                    >
                        <MenuIcon sx={{ color: "#000"}}/>
                    </IconButton>
                    <Drawer
                        anchor="left"
                        open={isDrawerOpen}
                        onClose={toggleDrawer(false)}
                    >
                        <Box
                            sx={{ 
                                width: 240
                            }}
                            role="presentation"
                            onKeyDown={toggleDrawer(false)}
                        >
                            <List>
                                {
                                    menuItems?.map((item, index) => (
                                        <ListItem button key={index} onClick={(event) => {
                                            console.log("event1: ", event)
                                            onMenuSelected(index, null, event)
                                            if (!item.subOptions) {
                                                setIsDrawerOpen(false)
                                            }
                                        }}>
                                            <Box>
                                            <ListItemText 
                                                primary={item.title} 
                                                sx={{ 
                                                    color: "#000",
                                                    borderLeft: selectedMenuIndex == index ? "3px solid #4680FF" : "none",
                                                    paddingLeft: selectedMenuIndex == index ? "7px" : "10px",
                                                }} />
                                            {
                                                subOptions && subOptions[0]?.menuIndex == index && subOptions.map((subItem, subIndex) => (
                                                    <ListItem button key={subIndex} onClick={(event) => {
                                                        console.log("event2: ", event)
                                                        onMenuSelected(index, subItem, event)
                                                        setIsDrawerOpen(false)
                                                    }}>
                                                        <ListItemText 
                                                            primary={subItem.title} 
                                                            sx={{ 
                                                                color: selectedSubOption?.subOptionId === subItem.subOptionId ? "#4680FF" : "#3b3b3b"
                                                            }}
                                                        />
                                                    </ListItem>
                                                ))
                                            }
                                            </Box>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    </Drawer>
                </Box>

                {/* Logo Centered */}
                <Box
                    component="img"
                    src={smartClickLogo}
                    alt="SmartClick Logo"
                    sx={{
                        height: 40,
                        margin: { xs: '0', md: '0 auto' }, // Align left for small devices, center for larger devices
                        display: { xs: 'block', md: 'block' },
                    }}
                />

                {/* Desktop Menu */}
                <Box sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1 }}>
                    <Menu items={menuItems} onMenuSelect={onMenuSelected} selectedMenuIndex={selectedMenuIndex} />
                </Box>

                {/* User Profile */}
                <Box sx={{ display: { xs: 'flex', md: 'flex' } }}>
                    <UserProfileCard
                        name={user.name}
                        role={user.plan?.plan_id ? t('navigationBar.subscribed') : t('navigationBar.notSubscribed')}
                        onClick={onUserProfileSelect}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default NavigationBar;
